// Date formatting utilities
export const formatDate = (date) => {
  if (!date) return '';
  return new Date(date).toLocaleDateString('en-GB');
};

export const formatDateTime = (date) => {
  if (!date) return '';
  return new Date(date).toLocaleString('en-GB');
};

// Mobile number formatting utilities
export const formatMobileNumber = (phoneNumber) => {
  if (!phoneNumber) return '';
  
  // Convert to string and remove any non-digit characters
  const cleanNumber = phoneNumber.toString().replace(/\D/g, '');
  
  // If number starts with 91 and is 12 digits, it's already formatted
  if (cleanNumber.startsWith('91') && cleanNumber.length === 12) {
    return cleanNumber;
  }
  
  // If number is 10 digits and doesn't start with 91, add country code
  if (cleanNumber.length === 10 && !cleanNumber.startsWith('91')) {
    return `91${cleanNumber}`;
  }
  
  // If number is 12 digits and starts with 91, return as is
  if (cleanNumber.length === 12 && cleanNumber.startsWith('91')) {
    return cleanNumber;
  }
  
  // For any other format, return the cleaned number
  return cleanNumber;
};

export const displayMobileNumber = (phoneNumber) => {
  if (!phoneNumber) return '';
  
  const formatted = formatMobileNumber(phoneNumber);
  
  // Display with proper formatting
  if (formatted.startsWith('91') && formatted.length === 12) {
    return `+${formatted}`;
  }
  
  return formatted;
};

export const validateMobileNumber = (phoneNumber) => {
  if (!phoneNumber) return false;
  
  const cleanNumber = phoneNumber.toString().replace(/\D/g, '');
  
  // Valid formats: 10 digits (without country code) or 12 digits (with 91)
  return (cleanNumber.length === 10) || (cleanNumber.length === 12 && cleanNumber.startsWith('91'));
}; 
